<template>
    <Dialog v-model:open="opened">
        <DialogTrigger> <slot /> </DialogTrigger>
        <DialogContent>
            <DialogHeader>
                <DialogTitle>
                    {{ $t("migrations.calendly.modal.title") }}</DialogTitle
                >
            </DialogHeader>

            <div class="mt-2">
                <div class="mt-4">
                    <label
                        for="workflow-name"
                        class="text-sm font-medium text-iron-700 block"
                        >{{
                            $t("migrations.calendly.modal.apiKeyLabel")
                        }}</label
                    >
                    <div class="mt-1 w-full">
                        <input
                            v-model="apiKey"
                            type="text"
                            data-cy="apiKey"
                            name="apiKey"
                            class="rounded-md border-iron-300 shadow-sm focus:border-z-orange-500 focus:ring-z-orange-500 sm:text-sm block w-full"
                            :placeholder="
                                $t(
                                    'migrations.calendly.modal.apiKeyPlaceholder',
                                )
                            "
                        />
                    </div>
                </div>
            </div>
            <DialogFooter>
                <button
                    type="button"
                    class="mt-3 rounded-md border-iron-300 bg-white px-4 py-2 text-base font-medium text-iron-700 shadow-sm hover:bg-iron-50 focus:ring-z-orange-500 sm:ml-3 sm:mt-0 sm:w-auto sm:text-sm inline-flex w-full justify-center border focus:ring-2 focus:ring-offset-2 focus:outline-none"
                    @click="closeModal"
                >
                    {{ $t("cancel") }}
                </button>
                <ZButton
                    class="ml-4"
                    type="button"
                    @click="migrateFromCalendly"
                    >{{ $t("migrations.migrate") }}</ZButton
                >
            </DialogFooter>
        </DialogContent>
    </Dialog>
</template>

<script setup lang="ts">
import ZButton from "../../../Atomic/Button.vue";
import { ref } from "vue";
import { router } from "@inertiajs/vue3";
import {
    Dialog,
    DialogContent,
    DialogFooter,
    DialogHeader,
    DialogTitle,
    DialogTrigger,
} from "@/components/ui/dialog";
import route from "ziggy-js";

defineProps({
    modelValue: Boolean,
});
const emits = defineEmits(["update:modelValue"]);

const apiKey = ref("" as string);
const opened = ref(false);

const migrateFromCalendly = function () {
    router.post(
        route("app.calendly-migrations.store"),
        {
            apiKey: apiKey.value,
        },
        {
            onFinish: () => {
                closeModal();
            },
        },
    );
};

const closeModal = () => {
    opened.value = false;
};
</script>

<style></style>
